"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
function Card(props) {
    return (
    // <div className="   border-r-4 border-b-4 border-gray-500">
    // <div className={classNames(" border-2 border-black mb-4", props.className)}>
    (0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)("border border-white/20 rounded-xl p-4", props.className), children: props.children }));
}
exports.Card = Card;
